// extracted by mini-css-extract-plugin
module.exports = {"modalOverlay":"ColorModal_modalOverlay__jb9Oz","modal":"ColorModal_modal__A1NCC"};